import { createSlice } from "@reduxjs/toolkit";

/**
 * whether we're currently re-taking a picture
 * value should be a boolean
 */
export const retakeSlice = createSlice({
  name: "retake",
  initialState: {
    value: false,
  },
  reducers: {
    update: (state, action) => {
      state.value = action.payload;
    },
    reset: (state) => {
      state.value = false;
    },
  },
});

export const { update, reset } = retakeSlice.actions;

export default retakeSlice.reducer;
